// extracted by mini-css-extract-plugin
module.exports = {"toastsWrapper":"RSxokP9T","toast":"TBRpiNag"};